export function getAudioDuration(file) {
    return new Promise((resolve, reject) => {
        const objectUrl = URL.createObjectURL(file);
        const audio = new Audio();

        const cleanup = () => {
            audio.onloadedmetadata = null;
            audio.onerror = null;
            URL.revokeObjectURL(objectUrl);
        };

        audio.preload = "metadata";

        audio.onloadedmetadata = () => {
            const durationSeconds = Math.floor(audio.duration);
            cleanup();

            if (Number.isFinite(durationSeconds)) {
                resolve(durationSeconds);
                return;
            }

            reject(new Error("Invalid audio duration"));
        };

        audio.onerror = () => {
            cleanup();
            reject(new Error("Unable to read audio metadata"));
        };

        audio.src = objectUrl;
    });
}
